// Generated types for NeoNode
// This file is auto-generated - do not edit manually

import { z } from 'zod';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface NeoNodeReadAPI {
  id?: string;
  /** Monotonically increasing version number for the node */
  version?: number;
}

export interface NeoNodeWriteAPI {
  id?: string;
  /** Monotonically increasing version number for the node */
  version?: number;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const NeoNodeReadAPISchemaObject = z.object({
  id: z.string().optional(),
  version: z.number().optional(),
}).passthrough();
export const NeoNodeReadAPISchema: z.ZodType<NeoNodeReadAPI> = NeoNodeReadAPISchemaObject;

export const NeoNodeWriteAPISchemaObject = z.object({
  id: z.string().optional(),
  version: z.number().optional(),
}).passthrough();
export const NeoNodeWriteAPISchema: z.ZodType<NeoNodeWriteAPI> = NeoNodeWriteAPISchemaObject;
